import { createGuest } from '../../../../utility/sb-api/sb-api.service';
import {
  closeModalSafely as closeModalSafelyBase,
  handleSubmit as handleSubmitBase,
} from '../modals.service';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = (
  event,
  errors,
  values,
  accessCode,
  isEditMode,
  setIsSubmitting,
  setTargetTable,
  closeModal,
  onSubmit,
  id,
) => {
  handleSubmitBase(
    `table-reservations/${id}/redeem`,
    null,
    null,
    'createTableReservationSuccess',
    'createTableReservationError',
    event,
    errors,
    values,
    { accessCode },
    isEditMode,
    setIsSubmitting,
    setTargetTable,
    closeModal,
    onSubmit,
  );
};
